<template>
    <tbody>
        <tr>
            <td style="width: 30%;">
                <Multiselect 
                    v-model="paint.paint_code"
                    :options="paint_list.map(x => x.paint_code)"
                    :allow-empty="false"
                />
            </td>
            <td style="width: 20%;">
                {{ paint.paint_name }}
            </td>
            <td style="width: 30%;">
                <input type="text" 
                    :disabled="!paint.paint_code"
                    v-model="paint.used_weight"
                    class="form-control"
                    style="height:43px"
                />
            </td>
            <td style="width: 10%;">
                {{ paintObj ? 'Rp. ' + numberWithCommas(paintObj.price_per_weight) : '-'}}
            </td>
            <td style="width: 10%;">
                {{ paint.total_price ? 'Rp. ' + numberWithCommas(paint.total_price) : '-'}}
            </td>
            <td style="width: 5%;">
                <button type="button" 
                    @click="$emit('removeIndex')"
                    class="btn btn-danger"
                ><i class="fa fa-times-circle"></i></button>
            </td>
        </tr>
    </tbody>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
    components : {
        Multiselect
    },
    props : ['paint_list' , 'paint' , 'index'],
    data () {
        return {
            paintObj : null
        }
    },
    mounted () {
        this.searchPaint()
    },
    watch : {
        'paint.paint_code' : {
            handler () {
                if(this.paint.paint_code) {
                    this.paintObj = this.paint_list.find(x => this.paint.paint_code == x.paint_code)
                    this.paint.paint_name = this.paintObj.paint_name

                }
                else {
                    this.paintObj = null
                    this.paint.paint_name = ''
                }
            }
        },
        'paint.used_weight' : function () {
            if(!this.paint.used_weight)
                this.paint.total_price = 0
            else {
                // let paintData = this.paint_list.find(x => this.paint.paint_code == x.paint_code)
                this.paint.total_price = parseFloat(this.paintObj.price_per_weight) / 1000 * parseFloat(this.paint.used_weight)
                // console.log(this.paint.total_price)
                // console.log(this.index + 'haha')
                this.$emit('updateCost', this.index)
            }
        }
    },
    methods : {
        searchPaint () {
            if(!this.paint.paint_code)
                return;
            
            this.paintObj = this.paint_list.find(x => this.paint.paint_code == x.paint_code)
        }
    }
}
</script>